import React from 'react';
import styled from 'styled-components';

import { ApiBalanceHistoryEvent } from 'api/types';
import MaterialSymbol from 'components/basic/icons/MaterialSymbol';
import VaultBalanceEventSign from 'components/vaults/components/VaultBalanceEventSign';
import {
  BANKROLL_BRIDGE_SOURCE,
  REWARDS_BRIDGE_SOURCE,
} from 'config/constants';
import { UnreachableCaseError } from 'lib/utils';

import downDownIcon from './icons/downDown.svg';

const TypeWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export default function BalanceTransactionType({
  transaction,
}: {
  transaction: ApiBalanceHistoryEvent;
}) {
  const type = transaction.type;
  const isVault = !!transaction.vault?.manager;
  switch (type) {
    case 'deposit':
      if (transaction.bridgeSource === BANKROLL_BRIDGE_SOURCE) {
        return (
          <TypeWrap>
            <img src={downDownIcon} style={{ width: 16, margin: 4 }} />{' '}
            &nbsp;&nbsp; Bankroll
          </TypeWrap>
        );
      }
      if (transaction.bridgeSource === REWARDS_BRIDGE_SOURCE) {
        return (
          <TypeWrap>
            <img src={downDownIcon} style={{ width: 16, margin: 4 }} />{' '}
            &nbsp;&nbsp; Referral Reward
          </TypeWrap>
        );
      }
    // Otherwise continue for standard Deposit & Pending one...
    // eslint-disable-next-line no-fallthrough
    case 'pendingDeposit':
      return (
        <TypeWrap>
          {isVault ? (
            <VaultBalanceEventSign type="deposit" />
          ) : (
            <MaterialSymbol icon="arrow_downward" color="var(--success)" />
          )}{' '}
          &nbsp;&nbsp; Deposit
        </TypeWrap>
      );
    case 'withdrawal':
      return (
        <TypeWrap>
          {isVault ? (
            <VaultBalanceEventSign type="withdrawal" />
          ) : (
            <MaterialSymbol icon="arrow_upward" color="var(--main)" />
          )}{' '}
          &nbsp;&nbsp; Withdrawal
        </TypeWrap>
      );
    case 'unknown':
      return <>Unknown</>;
    default:
      throw new UnreachableCaseError(type);
  }
}
